import React from 'react'
import PropTypes from 'prop-types'
import { LoaderDots, Modal } from '..'
import { Button, DialogActions, Wrapper, Title } from './style'

const Confirmation = ({
  title,
  onSubmit,
  open = false,
  submitText = 'yes',
  cancelText = 'no',
  showSubmitText = true,
  showCancelText = true,
  onClose,
  onCancel,
  loading = false,
  ...rest
}) => {
  return (
    <>
      {open && <Modal {...rest} title='' showClose={true} onClose={onClose || onCancel}>
        <Wrapper>
          <Title id='alert-dialog-title' variant='body1'>{title}</Title>
          <DialogActions>
            {loading && <LoaderDots />}
            {!loading && showCancelText && <Button variant='contained' color='primary' onClick={onCancel || onClose}> {cancelText}</Button>}
            {!loading && showSubmitText && <Button variant='contained' color='secondary' onClick={onSubmit} autoFocus>{submitText}</Button>}
          </DialogActions>
        </Wrapper>
      </Modal>}
    </>
  )
}

Confirmation.propTypes = {
  title: PropTypes.string,
  onSubmit: PropTypes.func,
  open: PropTypes.bool,
  submitText: PropTypes.string,
  cancelText: PropTypes.string,
  showSubmitText: PropTypes.string,
  showCancelText: PropTypes.string,
  onClose: PropTypes.func,
  onCancel: PropTypes.func,
  loading: PropTypes.bool
}

export default Confirmation
